// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mx68","col":"styles_col__xsEVD"};